function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var config$5 = {
  goibibo: '//pp.goibibo.com',
  appBannerUrl: '//authpp.goibibo.com',
  recommendEarnUrl: '//pp.goibibo.com/growth-dev-proxy',
  skywalkerUrl: '//pp.goibibo.com/growth-dev-proxy',
  dsdVoyager: '//voyagerx.goibibo.com'
};

var config$4 = {
  goibibo: '//newprodpp.goibibo.com',
  appBannerUrl: '//authprodpp.goibibo.com',
  recommendEarnUrl: '//influencer.goibibo.com',
  skywalkerUrl: '//mapi.goibibo.com',
  dsdVoyager: '//voyagerx.goibibo.com'
};

var config$3 = {
  goibibo: '//www.goibibo.com',
  appBannerUrl: '//auth.goibibo.com',
  recommendEarnUrl: '//influencer.goibibo.com',
  skywalkerUrl: '//mapi.goibibo.com',
  dsdVoyager: '//voyagerx.goibibo.com',
  recentSearchPush: '//pdt.goibibo.com'
};

var config$2 = {
  pokusUrl: '//pokus.goibibo.com',
  recommendEarnUrl: '//pp.goibibo.com/growth-dev-proxy',
  skywalkerUrl: '//mapi.goibibo.com',
  dsdVoyager: '//voyagerx.goibibo.com',
  voyager: '//voyager.goibibo.com',
  recentSearchPush: '//pdt.goibibo.com'
};

var config$1 = {
  goibibo: '//newprodpp.goibibo.com',
  appBannerUrl: '//authprodpp.goibibo.com',
  pokusUrl: '//pokus.goibibo.com',
  recommendEarnUrl: '//pp.goibibo.com/growth-dev-proxy',
  skywalkerUrl: '//mapi.goibibo.com',
  dsdVoyager: '//voyagerx.goibibo.com'
};

var endpoints = {
  appBannerUrl: '/v1/authapi/get/retained_state/login_link/',
  pokusUrl: '/experiment/assignVariant',
  userWidget: "/common/userwidget/?random=+" + Math.random(),
  // random to avoid browser cache
  recommendEarnUrl: "/recEarn/infl/details",
  skywalkerV1: '/empeiria/api/v1',
  dsdVoyager: '/api/v1/hotels_search/find_node_by_name',
  appContext: '/api/v2/utils/get_context/',
  recentSearchPush: '/fs/w'
};

var local = _extends({}, config$2, config$1);

var prod = _extends({}, config$2, config$3);

var prodpp = _extends({}, config$2, config$4);

var pp = _extends({}, config$2, config$5);

var config = {
  local: local,
  pp: pp,
  prodpp: prodpp,
  prod: prod
};

var getConfig = function getConfig(env) {
  var defaultEnv = 'prod';

  var normalizeEnvVar = function normalizeEnvVar(v) {
    var validEnvVar = function validEnvVar(ve) {
      return ['prod', 'pp', 'prodpp', 'local'].includes(ve);
    };

    if (!v || typeof v !== 'string') return false;

    if (!validEnvVar(v)) {
      console.error("getConfig:normalizeEnvVar:validEnvVar error, " + v + " is not a valid env");
      return false;
    }

    return v.toLowerCase();
  };

  var BuildEnv = normalizeEnvVar(env) || defaultEnv;
  return config[BuildEnv];
};

export { config as allConfig, getConfig as default, endpoints, local, pp, prod, prodpp };
